/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { Conversation } from '@/models';
import React, { createContext } from 'react';

interface DirectMessagesContextType {
  conversationsReceived: Conversation[];
  conversations: Conversation[];
  setConversationsReceived: React.Dispatch<React.SetStateAction<Conversation[]>>;
  setConversations: React.Dispatch<React.SetStateAction<Conversation[]>>;
}

export const DirectMessagesContext = createContext<DirectMessagesContextType | null>(null);
